import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
/**
 * 向URL添加参数
 * @param {string} url - 原始URL
 * @param {string} param - 要添加的参数
 * @returns {string} - 处理后的URL
 */
export function appendUrlParam(url, param) {
  if (!url) return '';
  var hasQueryString = url.includes('?');
  return "".concat(url).concat(hasQueryString ? '&' : '?').concat(param);
}